import { v4 as uuidv4 } from 'uuid';

const _callbacks = {};

function register(key, callback) {
  let id = uuidv4();
  let currMap;
  if (!(key in _callbacks)) {
    currMap = {};
    _callbacks[key] = currMap;
  }
  else {
    currMap = _callbacks[key];
  }

  currMap[id] = callback;

  return id;
}

function remove(key, id) {
  if (key in _callbacks) {
    delete _callbacks[key][id];
  }
}

function removeAll(key) {
  delete _callbacks[key];
}

function trigger(key) {
  if (key in _callbacks) {
    let currMap = _callbacks[key];
    for (const id in currMap) {
      currMap[id](...Array.from(arguments).slice(1));
    }
  }
}

export default {
  register,
  remove,
  removeAll,
  trigger,
};
